import { classNames } from '../../utils/helpers';

export function SkeletonLine({ className = '' }: { className?: string }) {
  return <div className={classNames('h-3.5 rounded bg-gray-200 animate-pulse', className)} />;
}

export function SkeletonCard({ className = '' }: { className?: string }) {
  return (
    <div className={classNames('bg-white rounded-xl border border-gray-200 p-5 space-y-3', className)}>
      <SkeletonLine className="w-1/3" />
      <SkeletonLine className="w-2/3" />
      <SkeletonLine className="w-1/2" />
    </div>
  );
}

export function SkeletonRows({ rows = 5, cols = 4 }: { rows?: number; cols?: number }) {
  return (
    <div className="divide-y divide-gray-100">
      {Array.from({ length: rows }).map((_, r) => (
        <div key={r} className="flex items-center gap-4 px-4 py-3">
          {Array.from({ length: cols }).map((_, c) => (
            <SkeletonLine key={c} className={c === 0 ? 'w-32' : 'flex-1'} />
          ))}
        </div>
      ))}
    </div>
  );
}

const Skeleton = { Line: SkeletonLine, Card: SkeletonCard, Rows: SkeletonRows };
export default Skeleton;
